import React, { Component } from "react";
import Countdown from "react-countdown-now";
import styled, { css } from "styled-components";

const Number = styled.p`
  font-size: 4.5rem;
  text-align: center;
  @media (max-width: 1030px) {
    text-align: left;
  }
`;

const Label = styled.p`
  font-size: 1.5rem;
  text-align: center;
  @media (max-width: 1030px) {
    text-align: left;
  }
`;

const ListItem = styled.li`
  display: inline-block;
  list-style-type: none;
  padding: 0 1rem;
  text-transform: uppercase;
  margin: 0 0.5rem;

  @media (max-width: 1030px) {
    padding: 1rem;
    margin: 0;
    text-align: left;
  }


  ${props =>
    props.poppins &&
    css`
      font-family: "Poppins", sans-serif;
    `}
    ${props =>
      props.first &&
      css`
        padding: 0 1rem 0 0;
        margin: 0 0.5rem 0 0;
      `}
    ${props =>
      props.last &&
      css`
        padding: 0 0 1rem 0;
        margin: 0 0 0.5rem 0;
      `}
`;

class Clock extends Component {
  render() {
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
      if (completed) {
        // Render a completed state
        return "Broken";
      } else {
        // Render a countdown
        return (
          <ul>
            <ListItem first>
              <Number>{days}</Number>
              <Label>days</Label>
            </ListItem>
            <ListItem>
              <Number>{hours}</Number>
              <Label>hours</Label>
            </ListItem>
            <ListItem>
              <Number>{minutes}</Number>
              <Label>minutes</Label>
            </ListItem>
            <ListItem last>
              <Number>{seconds}</Number>
              <Label>seconds</Label>
            </ListItem>
          </ul>
        );
      }
    };

    return (
      <Countdown
        date={new Date("19 January, 2038 03:14:07")}
        renderer={renderer}
      />
    );
  }
}

export default Clock;
